// extracted by mini-css-extract-plugin
export default {"option":"Option_option__QoZyw","title":"Option_title__8p3p1","description":"Option_description__71Dqf","btn":"Option_btn__vC2Df","icon":"Option_icon__2RDPb"};